import { Link } from "react-router-dom";

export default function Ctas({ light = false }: { light?: boolean }) {
  return (
    <div className="ctas">
      <Link className={light ? "btn btn-light" : "btn"} to="/events">
        See all events
      </Link>
      <Link className={light ? "btn btn-ghost-light" : "btn btn-ghost"} to="/contact">
        Get in touch
      </Link>
    </div>
  );
}
